export default __webpack_public_path__ + "_/images/registration/registration_ru-089b96c13f62bb2448a5c033e85ff91a613f290233b67ceb42b918c4a3c24a43.jpg";